import React from "react";
import { Container, Row, Col, Card, ListGroup, Button, Image, Table } from "react-bootstrap";
import { FaFacebook, FaTiktok, FaYoutube, FaInstagram, FaComment, FaArrowLeft, FaArrowRight } from "react-icons/fa";
import Footer from './footer';
import LatestUpdates from "./latestupdates";
import { motion } from "framer-motion";
import "./img.css";
import { Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";



const VisaTable = () => {
    return (
        <div className="container mt-4">
            <Table >
                <thead className="table-light">
                    <tr>
                        <th>TYPE</th>
                        <th>DESCRIPTION</th>
                        <th>STAY</th>
                        <th>COST</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            <strong>Australian Government Endorsed Events</strong>
                        </td>
                        <td>
                            This temporary visa lets you come to Australia to pAATicipate in events which are endorsed by the Australian Government.
                        </td>
                        <td>For the duration of the event or up to 4 years</td>
                        <td>From AUD310<br />

                            Free for COVID-19 Pandemic event</td>
                    </tr>

                    <tr>
                        <td>
                            <strong>Special Program</strong>
                        </td>
                        <td>
                            This visa lets you stay in Australia to take pAAT in an approved special program. Special programs can include youth exchange, cultural enrichment or community programs, school language assistants or “gap year school volunteering “.

                        </td>
                        <td>Up to 12 months</td>
                        <td>From AUD310</td>
                    </tr>
                    <tr>
                        <td>
                            <strong>Religious Work</strong>
                        </td>
                        <td>
                            This visa lets you do full-time religious work for a religious institution in Australia. You and your family who apply for the visa with you can stay here for up to 2 years.
                        </td>
                        <td>Up to 2 years</td>
                        <td>From AUD310

                        </td>
                    </tr>
                    <tr>
                        <td>
                            <strong>Research activities</strong>
                        </td>
                        <td>
                            This visa lets you observe or take pAAT in a research project at a research or tertiary institution in Australia. You and your family who apply for the visa with you can stay here for up to 2 years.
                        </td>

                        <td>Up to 2 years</td>
                        <td>From AUD310

                        </td>
                    </tr>
                    <tr>
                        <td>
                            <strong>Invited for other social and cultural activity (Invited PAATicipant)</strong>
                        </td>
                        <td>
                            This visa lets you come to Australia if you are invited to pAATicipate in a community-based event, including sporting events. You and your family who travel on the visa with you can stay here for up to 3 months.
                        </td>

                        <td>Up to 3 years</td>
                        <td>From AUD310

                        </td>
                    </tr>
                    <tr>
                        <td>
                            <strong>Sporting Activities</strong>
                        </td>
                        <td>
                            This visa allows you to play, coach, instruct or adjudicate for an Australian team, or do high level sports training with a sporting organisation. You and your family can stay in Australia for up to 2 years.
                        </td>

                        <td>Up to 2 years</td>
                        <td>From AUD310

                        </td>
                    </tr>
                    <tr>
                        <td>
                            <strong>Entertainment Activities</strong>
                        </td>
                        <td>
                        This temporary visa lets you come to Australia to work in the entertainment industry on film, television or live productions as a performer, production or support staff. You can include family members in your visa application.
                        </td>

                        <td>Up to 2 years</td>
                        <td>From AUD310

                        </td>
                    </tr>
                    <tr>
                        <td>
                            <strong>Superyacht Crew</strong>
                        </td>
                        <td>
                        This visa lets you work in Australia as a crew member of a superyacht. You can stay here for up to 12 months.
                        </td>

                        <td>Up to 12 months</td>
                        <td>From AUD310

                        </td>
                    </tr>
                    <tr>
                        <td>
                            <strong>Exchange Arrangements</strong>
                        </td>
                        <td>
                        This visa lets you come to Australia as pAAT of a staff exchange with an Australian organisation. You and your family members who travel here on the visa with you can stay for up to 2 years.
                        </td>

                        <td>Up to 2 years</td>
                        <td>From AUD310

                        </td>
                    </tr>
                    <tr>
                        <td>
                            <strong>Domestic work for executives</strong>
                        </td>
                        <td>
                        This visa lets you come to Australia to do full-time domestic work in the household of certain senior foreign executives. You and members of your family unit can stay here for up to 2 years.
                        </td>

                        <td>Up to 2 years</td>
                        <td>From AUD310

                        </td>
                    </tr>

                </tbody>
            </Table>
        </div>
    );
};



  





const ContentSection = () => (
    <Container className="mt-4">
        <Row>
            <Col md={8}>
                <h2>FEATURES OF TEMPORARY ACTIVITY VISA (SUBCLASS 408)</h2>
                <p className="mt-3">
                    This visa allows you to come to Australia to do specific types of work
                    on a short-term, temporary basis for any of the following reasons:</p>
                <ul>
                    <li>work in the entertainment industry</li>
                    <li>pAATicipate in activities at the invitation of an Australian organisation</li>
                    <li>pAATicipate or observe in an Australian research project</li>
                    <li>work in a skilled position under a staff exchange arrangement</li>
                    <li>pAATicipate in high-level sports competitions or sports training programs</li>
                    <li>pAATicipate in a special programme approved by the depAATment that provides
                        opportunities for youth exchange, cultural enrichment or community benefits</li>
                    <li>do full-time religious work</li>
                    <li>be employed as a superyacht crew member</li>
                    <li>do full-time domestic work in the household of certain senior foreign executives</li>
                    <li>pAATicipate in a government endorsed event. COVID-19 Pandemic event visa</li>
                </ul><br /><br />
                <p className="mt-3">This is a temporary visa. You can be in or outside Australian
                    when you apply for this visa and when the visa is granted.</p>
                <h4>BASIC ELIGIBILITY</h4>
                <p>You must:</p>
                <ul>
                    <li>have the skills to undertake the activity to be carried out in Australia</li>
                    <li>be supported or sponsored</li>
                    <li>meet additional requirements of the relevant stream</li>
                </ul>
                <h4>FINANCIAL SUPPORT</h4>
                <p className="mt-3">While you are in Australia, you must be able to support
                    yourself and any eligible dependant family members who come with you.
                    You might be asked to provide evidence of funds, such as an employment
                    contract, bank statements or a letter from your financial institution
                    stating your financial position. Allowances, accommodation and other
                    assistance from your employer can also be considered when looking at
                    your ability to support yourself.</p>
                <h4>ENGLISH LANGUAGE REQUIREMENTS</h4>
                <p className="mt-3">
                    Visa applicants for special program should have functional English language
                    (IELTS 4.5 or equivalent). This is to ensure that pAATicipants fully experience
                    the cultural and social benefits of the special programme and to ensure occupational
                    health and safety standards are met.
                </p>
                <h4>SPONSORSHIP REQUIREMENT</h4>
                <p className="mt-3">
                    If you apply in Australia or you apply outside Australia and you intend
                    to stay for more than 3 months you must provide the following from your sponsor:
                </p>
                <ul>
                    <li>Sponsors Transaction Reference Number or Sponsorship Application ID</li>
                    <li>Sponsor approval letter or receipt for lodgement of the sponsorship application</li>
                    <li>A written statement from the sponsor that they will meet the sponsorship
                        obligations for you and all dependent family members included in your application.
                    </li>
                </ul>
                <h4>APPLYING IN AUSTRALIA</h4>
                <p className="mt-3"> If you apply in Australia you must be sponsored by an approved temporary
                    activities sponsor or sponsor who passes the sponsorship test.</p>
                <h4>APPLYING OUTSIDE AUSTRALIA</h4>
                <p className="mt-3">If you apply from outside Australia and you intend to stay in
                    Australia for three months or less, the organisation or individual in Australia
                    who has responsibility for the events/activities you will be involved in must pass
                    the support test.</p>
                <p className="mt-3">If you apply from outside Australia and you intend to stay in
                    Australia for more than three months you must be sponsored by an approved
                    temporary activities sponsor or sponsor who passes the sponsorship test.</p>
                <h4>WHAT YOU CAN DO</h4>
                <p>This visa allows you to:</p>
                <ul>
                    <li>stay in Australia for the period that aligns with the activities
                        that you have been approved to undertake on this visa. The maximum
                        stay periods allowed are:</li>
                    <ul>
                        <li>Invited pAATicipant activity type – up to three months</li>
                        <li>Australian Government endorsed event activity type – up to four years</li>
                        <li>Any other activity type – up to two years</li>
                    </ul>
                    <li>do work or activity specified in your application</li>
                    <li>bring eligible family members with you to Australia</li>
                    <li>Do work or activity specified in your application</li>
                    <li>enter and leave Australia as many times as you want while your visa is valid.</li>

                </ul>
                <br />
                <VisaTable />
                <br />
                <h4>WHO CAN GET THIS VISA</h4>
                <p className="mt-3">You might be able to get this visa if you:</p>
                <ul>
                    <li>intend to stay in Australia for <b>three months or less </b>and apply from 
                        outside Australia, and you have the support of an organisation or individual
                         in Australia who has responsibility for the events or activities being 
                         undertaken who passes the<b> support test</b></li>
                         <li>intend to stay in Australia for<b> more than three months</b> and 
                            you are sponsored by an approved sponsor for this visa who passes the<b> sponsorship test</b></li>
                            <li>meet the requirements of the activity type in which you are applying for this visa</li>
                            <li>have adequate financial support for you and your family while you are in Australia</li>
                            <li>have adequate arrangements for health insurance while you are in Australia</li>
                            <li>meet health and character requirements</li>
                            <li>genuinely intend to remain temporarily in Australia to do the work or activity specified in your application.</li>
                </ul>
                <h4>GENUINE TEMPORARY ENTRANT</h4>
                <p className="mt-3">The genuine temporary entrant requirement (GTE) is an integrity measure to ensure that the 
                    temporary visa programme is used as intended and not as a way to maintain ongoing residency in Australia.
                     Temporary residents are generally not able to extend their stay in Australia beyond four years by applying for this visa.</p>
                     <p className="mt-3">The GTE requirement applies to all temporary activity visa applicants. The officer assessing the visa will 
                        consider whether the individual circumstances of the visa applicant indicates that their intention is for a temporary stay in Australia.</p>
                        <p className="mt-3">You must satisfy us that you have a genuine intention to stay in Australia temporarily.</p>
                        <p className="mt-3">When assessing the GTE requirement, we will consider:</p>
                        <ul>
                            <li>your circumstances</li>
                            <li>your immigration history</li>
                            <li>compliance with visa conditions</li>
                            <li>if you are under 18 years old, the intention of your parent, legal guardian or pAATner</li>
                            <li>any other relevant matter.​</li>
                        </ul><br/>
              
                <LatestUpdates />
            </Col>

            {/* Sidebar Section */}
            <Col md={4}>
                <Card className="p-3 text-center">
                    {/* Bajwa Immigration Image */}
                    <Image
                        src="./img/brand-logo.png"
                        alt="Bajwa Immigration Logo"
                        fluid
                        className="mb-3"
                    />

                    <h6 className="fw-bold">Subscribe to our YouTube channel</h6>
                    <Button variant="danger" className="mb-3"><a href="https://www.youtube.com/embed/uOGAB9oYets">SUBSCRIBE</a></Button>

                    <h6 className="fw-bold">Book Consultation</h6>
                    <Button variant="warning">BOOK CONSULTATION</Button>

                    <h6 className="fw-bold mt-3">Like Us on Facebook !!</h6>
                    {/* Facebook Embed */}
                    <iframe
                        src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2FBajwaImmigration&tabs&width=340&height=130&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId"
                        width="100%"
                        height="130"
                        style={{ border: "none", overflow: "hidden" }}
                        scrolling="no"
                        frameBorder="0"
                        allowFullScreen
                    ></iframe>

                    {/* Social Media */}
                    <h6 className="fw-bold mt-3">We are also on:</h6>
                    <div className="d-flex justify-content-center gap-3">
                        <FaInstagram size={30} color="#C13584" />
                        <FaTiktok size={30} color="#000" />
                        <FaYoutube size={30} color="crimson" />
                    </div>
                </Card>
            </Col>
        </Row>
    </Container>
);


const TempActivity = () => {
    return (
        <>
            <Container className="mt-4">
                <h1 className="fw-bold">Temporary Activity Visa (Subclass 408)</h1>

                {/* YouTube Embed Section */}
                <Row className="mt-3">
                    <Col md={8}>
                        <div className="ratio ratio-16x9">
                            <iframe
                                width="100%"
                                height="400"
                                src="https://www.youtube.com/embed/UiwspoFBEpA"
                                title="YouTube video"
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                            ></iframe>
                        </div>
                    </Col>

                    {/* Sidebar - Latest Posts */}
                    <Col md={4}>
                        <Card>
                            <Card.Header className="fw-bold">Latest Posts</Card.Header>
                            <ListGroup variant="flush">
                                <ListGroup.Item><Link to="/professional" className="dropdown-item"> <a href="" className="text-decoration-none">Professional Year</a> </Link></ListGroup.Item>
                                <ListGroup.Item><Link to="/coursechange" className="dropdown-item"> <a href="" className="text-decoration-none">Admissions And Course Change </a></Link></ListGroup.Item>
                                <ListGroup.Item><Link to="/skilledID" className="dropdown-item"> <a href="" className="text-decoration-none">   Skilled Independent Visa (Subclass 189)</a></Link></ListGroup.Item>
                                <ListGroup.Item><Link to="/workregionalvisa" className="dropdown-item"> <a href="" className="text-decoration-none">Skilled Work Regional Visa (Subclass 491)</a></Link></ListGroup.Item>
                                <ListGroup.Item><Link to="/nominatedvisa" className="dropdown-item"> <a href="" className="text-decoration-none">Skilled Nominated Visa (Subclass 190)</a></Link></ListGroup.Item>
                               <ListGroup.Item><a href="https://immi.homeaffairs.gov.au/visas/getting-a-visa/visa-listing/skilled-regional-191"className="dropdown-item text-decoration-none"style={{ color: "#22327f" }}target="_blank"rel="noopener noreferrer">Permanent Residence visa (Subclass 191)</a></ListGroup.Item>
                                {/* <ListGroup.Item><Link to="/regionalvisa" className="dropdown-item"><a href="" className="text-decoration-none">Skilled Regional Visa (Subclass 887)</a></Link></ListGroup.Item> */
                                <ListGroup.Item><Link to="/tempactivity" className="dropdown-item"><a href="" className="text-decoration-none">Temporary Activity Visa (Subclass 408)</a></Link></ListGroup.Item>
}
                            </ListGroup>
                        </Card>
                    </Col>
                </Row>
            </Container>

            {/* Content Section */}
            <ContentSection />


            {/* Floating Feedback Button */}
            <div className="position-fixed bottom-0 stAAT-0 m-3">
            <motion.button
    initial={{ x: "-100vw", opacity: 0 }}
    animate={{ x: 0, opacity: 1 }}
    transition={{ type: "tween", duration: 0.6, ease: "easeOut" }}
    className="btn btn-danger btn-sm position-fixed bottom-0 stAAT-0 m-3"
    style={{ zIndex: 1050 }}
>
    <i className="bi bi-chat-left-text me-1"></i>
    <a 
        href="https://au.bajwaimmigration.com/book-appointment" 
        className="text-white text-decoration-none"
    >
        Consult Now
    </a>
</motion.button>
            </div>
            <Footer />
        </>
    );
};

export default TempActivity;
